<template>
    <div class="map-dom-box" ref="hkMapDom">

    </div>
</template>

<script setup>

import {onBeforeMount, ref, onMounted, toRef} from "vue";
import * as echarts from 'echarts';
import * as HKJSON from "@/assets/HK.json"
import {hkDistrictList} from "@/util/hkDistrictCode";
import {useUserinfo} from "@/stores/userinfo";

const props = defineProps(["codeList"])
const emits = defineEmits(["select-complete"])

const userInfoRef = toRef(useUserinfo())

const hkMapDom = ref(null)
let mapChart = null
const districtValues = ref([
    { name: '中西区', value: 20057.34, code: "HCW" },
    { name: '湾仔', value: 15477.48, code: "HWC" },
    { name: '东区', value: 31686.1, code: "HEA" },
    { name: '南区', value: 6992.6, code: "HSO" },
    { name: '油尖旺', value: 44045.49, code: "KYT" },
    { name: '深水埗', value: 40689.64, code: "KSS" },
    { name: '九龙城', value: 37659.78, code: "KKC" },
    { name: '黄大仙', value: 45180.97, code: "KWT" },
    { name: '观塘', value: 55204.26, code: "KKT" },
    { name: '葵青', value: 21900.9, code: "NKT" },
    { name: '荃湾', value: 4918.26, code: "NTW" },
    { name: '屯门', value: 5881.84, code: "NTM" },
    { name: '元朗', value: 4178.01, code: "NYL" },
    { name: '北区', value: 2227.92, code: "NNO" },
    { name: '大埔', value: 2180.98, code: "NTP" },
    { name: '沙田', value: 9172.94, code: "NST" },
    { name: '西贡', value: 3368, code: "NSK" },
    { name: '离岛', value: 806.98, code: "NIS" },
])
const mapOption = {
    title: {
        // text: 'Map of Hong Kong',
        // subtext: 'Data from Wikipedia',
        // sublink:
        //     'http://zh.wikipedia.org/wiki/%E9%A6%99%E6%B8%AF%E8%A1%8C%E6%94%BF%E5%8D%80%E5%8A%83#cite_note-12'
    },
    tooltip: {
        trigger: 'item',
        // formatter: '{b}<br/>{c} (p / km2)'
        formatter: '{b}'
    },
    // toolbox: {
    //     show: true,
    //     orient: 'vertical',
    //     left: 'right',
    //     top: 'center',
    //     feature: {
    //         dataView: { readOnly: false },
    //         restore: {},
    //         saveAsImage: {}
    //     }
    // },
    visualMap: {
        min: 800,
        max: 50000,
        text: ['High', 'Low'],
        realtime: false,
        calculable: false,
        show: false,
        inRange: {
            color: ['lightskyblue', 'yellow', 'orangered']
        }
    },
    series: [
        {
            name: '香港地圖',
            type: 'map',
            map: 'HK',
            label: {
                show: true
            },
            data: districtValues.value,
            // 自定义名称映射
            nameMap: {}
        }
    ]
}

//國際化
const nameMap = {
    'Central and Western': '中西区',
    Eastern: '东区',
    Islands: '离岛',
    'Kowloon City': '九龙城',
    'Kwai Tsing': '葵青',
    'Kwun Tong': '观塘',
    North: '北区',
    'Sai Kung': '西贡',
    'Sha Tin': '沙田',
    'Sham Shui Po': '深水埗',
    Southern: '南区',
    'Tai Po': '大埔',
    'Tsuen Wan': '荃湾',
    'Tuen Mun': '屯门',
    'Wan Chai': '湾仔',
    'Wong Tai Sin': '黄大仙',
    'Yau Tsim Mong': '油尖旺',
    'Yuen Long': '元朗'
}

function initHKMap(){
    if (userInfoRef.value.lang === "zh" || userInfoRef.value.lang === "szh"){
        mapOption.series[0].nameMap = nameMap
    }

    if (userInfoRef.value.lang !== "zh" && userInfoRef.value.lang !== "szh"){
        districtValues.value.forEach((v, i) => {
            for (let i=0; i<hkDistrictList.length; i++){
                const obj = hkDistrictList[i]

                if (obj.countrycode === v.code){
                    v.name = obj.en
                    break;
                }

            }
        })
    }

    mapChart = echarts.init(hkMapDom.value)
    echarts.registerMap('HK', HKJSON)
    mapChart.setOption(mapOption)

    mapChart.on('click', clickMapEvent);
}

function clickMapEvent(event){
    emits("select-complete", event.data)
}

function saveCountry() {
    const codeList = []

    hkDistrictList.forEach((v, i) => {
        codeList.push({
            "countrycode": v.countrycode,
            "countryname": v.zh.trim(),
            "countryname2": v.en.trim(),
            "currcode": "HKD",
            "companycode": "ZZ"
        })
    })

    return JSON.stringify(codeList)
}

onBeforeMount(() => {

})

onMounted(() => {
    initHKMap()
})

</script>

<style scoped>

.map-dom-box {
    width: 100%;
    height: 100%;
}

</style>